import pineapple from './img/enso-logo.png';
import logo from './img/ensodata_left.png';

export const pineappleSrc = pineapple;
export const logoSrc = logo;
